<main class="splash-screen" role="main" aria-labelledby="splash-title">
    <div class="splash-content">
        <img
            src="/assets/images/placeholder-img.svg"
            width="396"
            height="300"
            class="splash-image"
            alt=""
            role="presentation"
        />
        <h1 class="splash-title" id="splash-title">Live More, Clean Less with Merry Maids!</h1>
    </div>
</main>
